import Header from 'components/headers/addLoan'
import { Field, Form, Formik } from 'formik'
import AddLoanIcon from 'assets/images/loans/add.svg'
import { useLocation, useNavigate } from 'react-router-dom'
import { Schema } from './utilities'
import { toast } from 'react-toastify'
import { useState } from 'react'
import SelectModal from 'components/modals/selectModal'
import { NumericFormat } from 'react-number-format'
import { Modal } from 'react-bootstrap'
import { AiOutlineInfoCircle } from 'react-icons/ai'
import posthog from 'posthog-js'

import {
    MoneyPoolCashinTypePortion,
    MoneyPoolCashinTypeCustom,
    MoneyPoolCashinTypeHibahExpense,
    MoneyPoolCashinTypeHibahCapital,
} from '../../../utilities/helper/moneyPools'
interface ISelectUser {
    name: string
    id: undefined | number
    memberId: undefined | number
}

const cashinTypeInfo: { title: string; desc: string }[] = [
    {
        title: 'پرداخت حق عضویت',
        desc: 'جزو سرمایه‌ی شخصی شما می‌شود و تعهدات ماهانه را نیز پرداخت می‌کند.',
    },
    {
        title: 'افزایش موجودی',
        desc: 'جزو سرمایه‌ی شخصی شما می‌شود ولی اثری روی تعهدات ماهانه ندارد.',
    },
    {
        title: 'هبه برای پوشش هزینه صندوق',
        desc: 'مدیر صندوق می‌تواند برای هزینه‌های صندوق از این مبلغ استفاده کند؛ مثلاً برای پرداخت هزینه‌ی اشتراک صندوق در همیان. این مبلغ جزو سرمایه‌ی شخصی شما نمی‌شود.',
    },
    {
        title: 'هبه بلاعوض به صندوق',
        desc: 'مدیر صندوق می‌تواند از این مبلغ برای وام‌دهی استفاده کند و جزو سرمایه‌ی شخصی شما محسوب نمی‌شود.',
    },
]
export default function DepositPage() {
    const [isOpenReceiver, setIsOpenReceiver] = useState<boolean>(false)
    const [isOpenInfo, setIsOpenInfo] = useState<boolean>(false)
    const [memberId, setMemberId] = useState<undefined | number>()
    const [trustState, setTrustState] = useState<boolean>(false)
    const navigate = useNavigate()
    const { state } = useLocation()

    // Android shows the «پرداخت کننده» picker to anyone whose role is not
    // normal (MoneypoolAddCashinActivity:72). This used to test `=== 'mgr'`
    // only, which hid it from every fund *owner* — 41,933 live funds have an
    // `own` holder against 626 with a `mgr`, so in practice the picker was
    // invisible and managers could only ever deposit for themselves.
    const isManager = state?.role === 'mgr' || state?.role === 'own'

    // Default the payer to the caller's own poolship so the flow behaves
    // exactly as before for the common case; picking someone else is opt-in.
    // Without this, `selectedUser?.id` was undefined until the manager opened
    // the modal, and the whole request went out with `poolship: undefined`.
    const profile = JSON.parse(localStorage.getItem('profile') || '{}')
    const selfPoolShipId = state?.selfPoolShipId ?? state?.poolShipId
    const [selectedUser, setSelectedUser] = useState<ISelectUser | undefined>({
        name:
            state?.selfName ||
            [profile?.first_name, profile?.last_name].filter(Boolean).join(' '),
        id: selfPoolShipId,
        memberId: profile?.id,
    })

    const payerPoolShipId = isManager ? selectedUser?.id : selfPoolShipId
    const isPayingForOther = isManager && payerPoolShipId !== selfPoolShipId

    return (
        <>
            <Formik
                initialValues={{
                    amount: '',
                    type: '',
                    tag: '',
                }}
                onSubmit={(values) => {
                    if (values.type.length === 0) {
                        toast.error('فیلد بابت ضروری می باشد')
                    } else if (!payerPoolShipId) {
                        toast.error('پرداخت کننده را انتخاب کنید')
                    } else {
                        posthog.capture('deposit_started', {
                            fund_id: state?.moneyPoolId,
                            deposit_type: values.type,
                            is_manager: isManager,
                            is_for_other_member: isPayingForOther,
                        })
                        navigate('/loans/transaction', {
                            state: {
                                formikValue: values,
                                poolShipId: payerPoolShipId,
                                payerName: selectedUser?.name,
                                isPayingForOther,
                                name: state?.name,
                                moneyPoolId: state?.moneyPoolId,
                                role: state?.role,
                                trustState: state?.trustState,
                            },
                        })
                    }
                }}
                validationSchema={Schema}
            >
                {({ values, touched, errors, setFieldValue }) => (
                    <Form>
                        <div className=" mx-3 flex flex-col h-screen ">
                            <div className=" grow-0">
                                <Header title="واریز به صندوق" />
                            </div>
                            <div className=" rounded-lg grow">
                                <div className=" mt-24 bg-white rounded-lg relative pt-1 shadow-[rgba(50,50,93,0.25)_0px_6px_12px_-2px,_rgba(0,0,0,0.3)_0px_3px_7px_-3px]">
                                    <img
                                        src={AddLoanIcon}
                                        alt="add-loan"
                                        className=" absolute right-[35%] -top-14"
                                    />
                                    <div className=" mt-14 w-full">
                                        <p className=" text-sm text-center text-gray-1">
                                            {' '}
                                            مبلغ واریز:
                                        </p>
                                        <NumericFormat
                                            customInput={Field}
                                            thousandSeparator
                                            placeholder="مبلغ(تومان)"
                                            allowNegative={false}
                                            name="amount"
                                            className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3"
                                            onValueChange={(values) => {
                                                const { value } = values
                                                setFieldValue('amount', value)
                                            }}
                                        />
                                        {errors.amount && touched.amount && (
                                            <p className=" text-sm text-error-3 text-center">
                                                {errors.amount}
                                            </p>
                                        )}
                                        {isManager && (
                                            <div
                                                onClick={() =>
                                                    setIsOpenReceiver(true)
                                                }
                                                className="w-full outline-0 cursor-pointer text-center border-b border-dashed border-gray-1 py-3 bg-white"
                                            >
                                                <span className="text-gray-1 text-sm">
                                                    پرداخت کننده:{' '}
                                                </span>
                                                <span
                                                    className={
                                                        selectedUser?.name
                                                            ? 'text-gray-800'
                                                            : 'text-placeholder'
                                                    }
                                                >
                                                    {selectedUser?.name ||
                                                        'انتخاب کنید'}
                                                </span>
                                            </div>
                                        )}

                                        <div className=" flex items-center w-full border-b border-dashed border-gray-1">
                                            <Field
                                                as="select"
                                                className="grow outline-0 text-center py-3 text-placeholder bg-white"
                                                name="type"
                                            >
                                                <option
                                                    className=" text-gray-1"
                                                    value=""
                                                >
                                                    بابت
                                                </option>
                                                <option
                                                    value={
                                                        MoneyPoolCashinTypePortion
                                                    }
                                                >
                                                    پرداخت حق عضویت
                                                </option>
                                                <option
                                                    value={
                                                        MoneyPoolCashinTypeCustom
                                                    }
                                                >
                                                    افزایش موجودی
                                                </option>
                                                <option
                                                    value={
                                                        MoneyPoolCashinTypeHibahExpense
                                                    }
                                                >
                                                    هبه برای پوشش هزینه صندوق
                                                </option>
                                                <option
                                                    value={
                                                        MoneyPoolCashinTypeHibahCapital
                                                    }
                                                >
                                                    هبه بلاعوض به صندوق
                                                </option>
                                            </Field>
                                            <AiOutlineInfoCircle
                                                onClick={() =>
                                                    setIsOpenInfo(true)
                                                }
                                                className=" text-green-1 shrink-0 ml-2 cursor-pointer"
                                                size={22}
                                                title="راهنمای انواع واریز"
                                            />
                                        </div>
                                        <Field
                                            as="textarea"
                                            name="tag"
                                            className="w-full outline-0 text-center py-4 px-4 text-sm"
                                            placeholder="توضیحات"
                                        />
                                    </div>
                                </div>
                            </div>
                            <button
                                className=" grow-0 bg-green-1 text-white py-3 rounded-lg"
                                type="submit"
                            >
                                واریز
                            </button>
                            <button
                                type="button"
                                className=" text-center my-3 text-gray-4"
                                onClick={() => navigate(-1)}
                            >
                                بعدا
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
            <SelectModal
                show={isOpenReceiver}
                onHide={() => setIsOpenReceiver(false)}
                setSelectedUser={setSelectedUser}
                setMemberId={setMemberId}
                title="پرداخت کننده را انتخاب کنید"
            />
            <Modal
                show={isOpenInfo}
                onHide={() => setIsOpenInfo(false)}
                centered
            >
                <div className=" py-4 px-4">
                    <p className=" text-center text-sm text-green-1 mb-3">
                        راهنمای انواع واریز
                    </p>
                    {cashinTypeInfo.map((item) => (
                        <div key={item.title} className=" mb-3">
                            <p className=" text-sm font-bold text-gray-800">
                                {item.title}
                            </p>
                            <p className=" text-xs text-gray-1 leading-6">
                                {item.desc}
                            </p>
                        </div>
                    ))}
                    <button
                        type="button"
                        className=" w-full bg-green-1 text-white py-2 rounded-lg mt-2"
                        onClick={() => setIsOpenInfo(false)}
                    >
                        متوجه شدم
                    </button>
                </div>
            </Modal>
        </>
    )
}
